import invoiceEntity from "../entitites/invoice";
import dayjs from "dayjs";
import _ from "lodash";

export const craftInvoices = (resource) => {
  const craftedInvoices = resource.reduce((acc, curr) => {
    let formattedInvoice = {};

    Object.keys(invoiceEntity).forEach((prop) => {
      const entityProp = invoiceEntity[prop];
      let resourceProp = curr[prop] ?? entityProp.default;

      const formattedValue = formatter(resourceProp, entityProp);

      if (formattedValue === undefined) {
        console.log("resourceProp: ", resourceProp);
        console.log("entityProp: ", entityProp);
        console.log("prop: ", prop);
        console.log("curr: ", curr);
      }

      formattedInvoice[entityProp.value] =
        formattedValue !== undefined ? formattedValue : resourceProp.default;
    });

    acc.push(formattedInvoice);
    return acc;
  }, []);

  return craftedInvoices;
};

function formatter(value, formaterType) {
  if (formaterType.default === value) return value;

  if (formaterType.type === "text") {
    return value.toString();
  }
  if (formaterType.type === "date") {
    if (value === null) return null;
    const lowerCaseValue = value.toLowerCase().trim() ?? "";

    if (!lowerCaseValue) return null;

    const isValidDate = dayjs(lowerCaseValue, formaterType.format).isValid();

    if (!isValidDate) console.log(lowerCaseValue, formaterType.format);

    return isValidDate ? dayjs(lowerCaseValue, formaterType.format) : null;
  }
  if (formaterType.type === "number") {
    if (typeof value === "number") return value;
    const removedExtranousSymbols = value.replace(/[^0-9.]/g, "");

    return isNaN(parseInt(removedExtranousSymbols))
      ? 0
      : Number(removedExtranousSymbols);
  }
  if (formaterType.type === "array") {
    return _.isArray(value) ? value : value.split(";");
  }
  if (formaterType.type === "boolean") {
    return value === "1";
  } else return formaterType.default;
}
